import styled from 'styled-components';

const StyledWrapper = styled.div`
	height: 110px;
`;

export { StyledWrapper };
